import React, { useState } from "react"
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import List from "./List"
import { Helmet } from "react-helmet"
import AddEditModel from "../Add/AddEditModel"
function Prefix() {
  const BreadcrumbDetails = {
    breadcrumbItem: {
      label: "List",
      link: "/prefix/list",
    },
    paths: [
      {
        label: "Setting",
        link: "/prefix/list",
      },
      {
        label: "Prefix",
        link: "/prefix/list",
      },
    ],
  }
  const [openAddEditModal, setOpenAppEditModal] = useState(false)
  const [load, setLoad] = useState(false)

  const [id, setId] = useState(null)
  const onAddRole = ID => {
    if (ID) {
      setId(ID)
    }
    setOpenAppEditModal(true)
  }
  return (
    <React.Fragment>
      <Helmet>
        <title>Prefix List | Discover Equestrian</title>
      </Helmet>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs breadcrumbDetails={BreadcrumbDetails} />
          <Row>
            <List setLoad={setLoad} load={load} onAddRole={onAddRole} />
          </Row>
          <AddEditModel
            openModal={openAddEditModal}
            setOpenModal={setOpenAppEditModal}
            setLoadList={setLoad}
            load={load}
            setId={setId}
            id={id}
          />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Prefix
